import { EVENT_TYPE } from '@/common/resources/const'
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '@/common/utils/request.const'
import {
  isActionTypeDisplay,
  isActionTypeClick,
  isElementTypeContainer,
  isElementTypeViewMore,
  isElementTypeCategory,
  isExecuteTypePlay,
  isExecuteTypeLanding,
  isExecuteTypeFetch,
  isExecuteTypeToggle,
} from '@/common/converter/utils/element'
import { convertHttpMethod } from '@/common/converter/utils/http-method'
import { getPreExecuteToastText } from '@/common/utils/home/get-pre-execute-toast'
import { isEmptyObject } from '@/common/converter/utils/is-empty-object'
import { getContentIdType } from '@/common/converter/utils/get-content-id-type'

/**
 * get event 'on-content'
 * use in band level
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnContent = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.actionList?.filter(isActionTypeDisplay).find(isExecuteTypeFetch) ??
    {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_CONTENT,
    url: action?.execute?.data?.url ?? '',
    method: convertHttpMethod(action?.execute?.data?.method),
    bodyList: action?.execute?.data?.body ?? [],
  }
}

/**
 * get event 'on-display'
 * use in band level
 * @param elementList
 * @returns {{isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnDisplay = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.actionList?.filter(isActionTypeDisplay).find(isExecuteTypeFetch) ??
    {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_DISPLAY,
    url: action?.execute?.logging?.url ?? '',
    method: HTTP_METHOD_POST,
    bodyList: action?.execute?.logging?.body ?? [],
  }
}

/**
 * get event 'on-view-more'
 * use in band level
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, title: (*|string), url: (*|string)}}
 */
export const getOnViewMore = (elementList = []) => {
  const element = elementList.find(isElementTypeViewMore) ?? {}
  const action =
    element?.actionList?.filter(isActionTypeClick).find(isExecuteTypeLanding) ??
    {}

  const title = element?.property?.text ?? ''

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_VIEW_MORE,
    title,
    url: action?.execute?.data?.url ?? '',
    method: convertHttpMethod(action?.execute?.data?.method),
    bodyList: action?.execute?.data?.body ?? [],
  }
}

/**
 * get event 'on-navigation'
 * use in cell level
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnNavigation = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const actionTypeClickArray =
    element?.contextActionList?.filter(isActionTypeClick)
  const action = actionTypeClickArray.find(isExecuteTypeLanding) ?? {}
  const cta = actionTypeClickArray.find(isExecuteTypePlay) ?? {}
  const toastText = getPreExecuteToastText(action?.preExecute)

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_NAVIGATION,
    url: action?.execute?.data?.url ?? '',
    cta: !isEmptyObject(cta) ? 'icon_autoplay' : '',
    method: convertHttpMethod(action?.execute?.data?.method),
    bodyList: action?.execute?.data?.body ?? [],
    toastText,
  }
}

/**
 * get event 'on-navigation' only use in category element
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnNavigationCategory = (elementList = []) => {
  const element = elementList?.find(isElementTypeCategory) ?? {}
  const action =
    element?.actionList?.filter(isActionTypeClick).find(isExecuteTypeLanding) ??
    {}
  const toastText = getPreExecuteToastText(action?.preExecute)

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_NAVIGATION,
    url: action?.execute?.data?.url ?? '',
    method: convertHttpMethod(action?.execute?.data?.method),
    bodyList: action?.execute?.data?.body ?? [],
    toastText,
  }
}

/**
 * get event 'on-click'
 * use in cell level
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnClick = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.contextActionList
      ?.filter(isActionTypeClick)
      .find(isExecuteTypeLanding) ?? {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_CLICK,
    url: action?.execute?.logging?.url ?? '',
    method: HTTP_METHOD_POST,
    bodyList: action?.execute?.logging?.body ?? [],
  }
}

/**
 * get event 'on-click' only use in category element
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnClickCategory = (elementList = []) => {
  const element = elementList?.find(isElementTypeCategory) ?? {}
  const action =
    element?.actionList?.filter(isActionTypeClick).find(isExecuteTypeLanding) ??
    {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_CLICK,
    url: action?.execute?.logging?.url ?? '',
    method: HTTP_METHOD_POST,
    bodyList: action?.execute?.logging?.body ?? [],
  }
}

/**
 * get event 'on-zzim'
 * use in cell level
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnZzim = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.contextActionList
      ?.filter(isActionTypeClick)
      .find(isExecuteTypeToggle) ??
    element?.topContextActionList
      ?.filter(isActionTypeClick)
      .find(isExecuteTypeToggle) ??
    {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_ZZIM,
    url: action?.execute?.data?.url ?? '',
    method: HTTP_METHOD_POST,
    bodyList: action?.execute?.data?.body ?? [],
  }
}

/**
 * get event 'off-zzim'
 * use in cell level
 * @param elementList
 * @returns {{method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOffZzim = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.contextActionList
      ?.filter(isActionTypeClick)
      .find(isExecuteTypeToggle) ??
    element?.topContextActionList
      ?.filter(isActionTypeClick)
      .find(isExecuteTypeToggle) ??
    {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.OFF_ZZIM,
    url: action?.execute?.data?.url ?? '',
    method: HTTP_METHOD_POST,
    bodyList: action?.execute?.data?.body ?? [],
  }
}

/**
 * get event 'on-instant-play'
 * use in cell level
 * @param elementList
 * @returns {{method: string, isRender: boolean, contentId: string, bodyList: (*|*[]), type: string, contentType: string}}
 */
export const getOnInstantPlay = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.contextActionList
      ?.filter(isActionTypeDisplay)
      .find(isExecuteTypePlay) ?? {}

  const { contentId, contentType } = getContentIdType(
    action?.execute?.data?.url,
  )

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_INSTANT_PLAY,
    contentId,
    contentType,
    method: HTTP_METHOD_GET,
    bodyList: action?.execute?.data?.body ?? [],
  }
}

/**
 * get event 'on-detail'
 * use in cell level
 * @param elementList
 * @returns {{cta: string, method: string, isRender: boolean, bodyList: (*|*[]), type: string, url: (*|string)}}
 */
export const getOnDetail = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action =
    element?.contextActionList
      ?.filter(isActionTypeClick)
      .find(isExecuteTypePlay) ?? {}

  return {
    isRender: !isEmptyObject(action),
    type: EVENT_TYPE.ON_DETAIL,
    url: action?.execute?.data?.url ?? '',
    cta: 'icon_information', // context.cta
    method: convertHttpMethod(action?.execute?.data?.method),
    bodyList: action?.execute?.data?.body ?? [],
  }
}
